// Glow Tic-Tac-Toe Client (2 Players)
import { sounds } from '../sound.js';

export class TicTacToeClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.board = Array(9).fill(null);
    this.playerX = null;
    this.playerO = null;
    this.currentTurn = 'X';

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="ttt-wrapper">
        <div class="ttt-header">
          <h2>⭕ GLOW TIC-TAC-TOE</h2>
          <div id="ttt-turn-badge" class="ttt-badge">Turn: Player X</div>
        </div>

        <div class="ttt-players-row">
          <div class="ttt-p-card x" id="ttt-px-card">
            <span class="mark">✕</span>
            <span id="ttt-px-name">Player X</span>
          </div>
          <div class="ttt-vs">VS</div>
          <div class="ttt-p-card o" id="ttt-po-card">
            <span class="mark">◯</span>
            <span id="ttt-po-name">Player O</span>
          </div>
        </div>

        <!-- 3x3 Grid -->
        <div class="ttt-grid-box">
          <div class="ttt-grid" id="ttt-grid">
            ${[0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => `
              <div class="ttt-cell" data-index="${i}"></div>
            `).join('')}
          </div>
        </div>
      </div>
    `;

    this.setupClicks();
  }

  setupClicks() {
    document.querySelectorAll('.ttt-cell').forEach((cell) => {
      cell.addEventListener('click', () => {
        const idx = parseInt(cell.dataset.index);
        sounds.playPop();
        this.socket.emit('ttt_move', { cellIndex: idx });
      });
    });
  }

  setupSocketEvents() {
    this.socket.on('ttt_started', (data) => {
      this.playerX = data.playerX;
      this.playerO = data.playerO;
      this.board = data.board;
      this.currentTurn = data.currentTurn;

      const pxName = document.getElementById('ttt-px-name');
      const poName = document.getElementById('ttt-po-name');
      if (pxName) pxName.innerText = this.playerX?.name || 'Player X';
      if (poName) poName.innerText = this.playerO?.name || 'Player O';

      this.updateBoardUI();
      this.updateTurnUI();
    });

    this.socket.on('ttt_moveMade', (data) => {
      sounds.playChime();
      this.board = data.board;
      this.currentTurn = data.currentTurn;
      this.updateBoardUI();
      this.updateTurnUI();
    });

    this.socket.on('ttt_gameOver', (data) => {
      sounds.playVictory();
      const badge = document.getElementById('ttt-turn-badge');
      if (badge) {
        badge.innerText = data.winner ? `🏆 WINNER: ${data.winner.name}!` : '🤝 DRAW MATCH!';
        badge.style.color = '#fbbf24';
      }
    });
  }

  updateBoardUI() {
    document.querySelectorAll('.ttt-cell').forEach((cell) => {
      const idx = parseInt(cell.dataset.index);
      const val = this.board[idx];
      cell.innerText = val ? (val === 'X' ? '✕' : '◯') : '';
      cell.className = `ttt-cell ${val ? val.toLowerCase() : ''}`;
    });
  }

  updateTurnUI() {
    const badge = document.getElementById('ttt-turn-badge');
    const pxCard = document.getElementById('ttt-px-card');
    const poCard = document.getElementById('ttt-po-card');

    if (this.currentTurn === 'X') {
      if (badge) badge.innerText = `Turn: ${this.playerX?.name || 'Player X'} (✕)`;
      pxCard?.classList.add('active');
      poCard?.classList.remove('active');
    } else {
      if (badge) badge.innerText = `Turn: ${this.playerO?.name || 'Player O'} (◯)`;
      poCard?.classList.add('active');
      pxCard?.classList.remove('active');
    }
  }

  destroy() {
    this.socket.off('ttt_started');
    this.socket.off('ttt_moveMade');
    this.socket.off('ttt_gameOver');
  }
}
